export const en = {
    'copy-message': 'Copied'
};
